import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useLang } from "../context/LangContext";
import { useCart } from "../context/CartContext";
import { pickLang, t } from "../lib/i18n";
import { api } from "../lib/api";
import { Plus, CheckCircle, ArrowLeft } from "@phosphor-icons/react";
import { toast } from "sonner";
import SEO from "../components/SEO";

export default function ProductDetail() {
  const { id } = useParams();
  const { lang } = useLang();
  const { add } = useCart();
  const [p, setP] = useState(null);

  useEffect(() => { api.get(`/products/${id}`).then((r) => setP(r.data)).catch(() => setP(false)); }, [id]);

  if (p === null) return <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-32 text-gray-400">Loading...</div>;
  if (p === false) return <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-32 text-gray-400">Not found. <Link to="/products" className="link-neon">Back</Link></div>;

  return (
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-16" data-testid="product-detail-page">
      <SEO
        title={p.name}
        description={p.short_desc}
        image={p.image}
        path={`/products/${p.id}`}
      />
      <Link to="/products" className="inline-flex items-center gap-2 mono-font text-xs uppercase tracking-[0.2em] text-gray-400 hover:text-[#ccff00] mb-10">
        <ArrowLeft size={14} /> {lang === "gr" ? "Πίσω" : "Back"}
      </Link>

      <div className="grid lg:grid-cols-2 gap-12">
        <div className="bg-[#0a0a0c] aspect-square overflow-hidden">
          {p.image && <img src={p.image} alt={pickLang(p.name, lang)} className="w-full h-full object-cover" />}
        </div>

        <div>
          <div className="mono-font text-xs uppercase tracking-[0.25em] text-gray-500">{p.brand} · {p.sku}</div>
          <h1 className="display-font text-4xl sm:text-5xl font-black uppercase tracking-tight mt-3" data-testid="product-name">
            {pickLang(p.name, lang)}
          </h1>
          <div className="text-2xl neon-text mono-font mt-4">{p.price_text}</div>

          <p className="text-gray-300 mt-8 leading-relaxed">{pickLang(p.description, lang)}</p>

          {p.specs && p.specs.length > 0 && (
            <div className="mt-8">
              <div className="label-tag mb-4">{lang === "gr" ? "Προδιαγραφές" : "Specs"}</div>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {p.specs.map((s, i) => (
                  <li key={i} className="flex items-start gap-2 text-gray-200 text-sm">
                    <CheckCircle size={16} weight="fill" className="text-[#ccff00] mt-0.5" /> {s}
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div className="flex flex-wrap gap-4 mt-10">
            <button
              onClick={() => { add(p); toast.success(lang === "gr" ? "Προστέθηκε" : "Added to quote"); }}
              className="btn-primary"
              data-testid="product-add-quote"
            >
              <Plus size={18} weight="bold" /> {t("cta.add_to_quote", lang)}
            </button>
            <Link to="/contact" className="btn-outline">{t("cta.send", lang)}</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
